"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_ui_1 = require("@pasport/react-ui");
function Popup({ children, width = "15rem", hideCloseButton = false, onClose }) {
    const arrowSize = "17px";
    const smallerArrowSize = "16px";
    const version = "white";
    const closeButtonOffset = "6px";
    const onCloseHandle = (e) => {
        e.stopPropagation();
        onClose?.();
    };
    return ((0, jsx_runtime_1.jsxs)("div", { className: "text-black", style: {
            position: "absolute",
            top: 0,
            left: "50%",
            transform: `translate(-50%, -100%) translateY(-${arrowSize})`
        }, children: [(0, jsx_runtime_1.jsxs)(react_ui_1.Card, { version: version, children: [(0, jsx_runtime_1.jsx)("div", { style: {
                            zIndex: 1,
                            width: width
                        }, className: "p-2", children: children }), !hideCloseButton && ((0, jsx_runtime_1.jsx)("div", { style: {
                            position: "absolute",
                            top: closeButtonOffset,
                            right: closeButtonOffset,
                            zIndex: 2
                        }, children: (0, jsx_runtime_1.jsx)("button", { onClick: onCloseHandle, type: "button", className: "btn-close", "aria-label": "Close" }) }))] }), (0, jsx_runtime_1.jsx)("div", { className: `bg-${version}`, style: {
                    width: smallerArrowSize,
                    height: smallerArrowSize,
                    zIndex: 0,
                    position: "absolute",
                    left: "50%",
                    transform: "translateX(-50%) translateY(-50%) translateY(-1px) rotate(45deg)"
                } }), (0, jsx_runtime_1.jsx)("div", { className: `bg-${version}`, style: {
                    width: arrowSize,
                    height: arrowSize,
                    zIndex: -1,
                    position: "absolute",
                    left: "50%",
                    transform: "translateX(-50%) translateY(-50%) rotate(45deg)"
                } })] }));
}
exports.default = Popup;
